var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('v-pagination',_vm._g(_vm._b({},'v-pagination',_vm.$props,false),_vm.paginationListeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }